import { render, staticRenderFns } from "./Livraison.vue?vue&type=template&id=30f91b18&scoped=true"
import script from "./Livraison.vue?vue&type=script&lang=js"
export * from "./Livraison.vue?vue&type=script&lang=js"
import style0 from "./Livraison.vue?vue&type=style&index=0&id=30f91b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f91b18",
  null
  
)

export default component.exports